"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _classnames = _interopRequireDefault(require("classnames"));
var _Heading = _interopRequireDefault(require("../../Atoms/Heading"));
require("./Accordion.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Accordion = function Accordion(_ref) {
  var isLargeAccordion = _ref.isLargeAccordion,
    heading = _ref.heading,
    collapseIcon = _ref.collapseIcon,
    openIcon = _ref.openIcon,
    children = _ref.children,
    elementLocator = _ref.elementLocator,
    _ref$isExpand = _ref.isExpand,
    isExpand = _ref$isExpand === void 0 ? false : _ref$isExpand;
  var _useState = (0, _react.useState)(isExpand),
    isActive = _useState[0],
    setIsActive = _useState[1];
  var iconUrl = isActive ? openIcon : collapseIcon;
  var classes = (0, _classnames.default)('accordion-row', {
    'accordion-large': isLargeAccordion,
    active: isActive
  });
  var handleOnClick = function handleOnClick() {
    return setIsActive(!isActive);
  };
  var handleKeyAction = function handleKeyAction(e) {
    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      handleOnClick();
    }
  };
  return _react.default.createElement("div", {
    className: classes,
    role: "button",
    tabIndex: 0,
    onKeyPress: handleKeyAction
  }, _react.default.createElement("div", {
    className: "heading-container",
    onClick: handleOnClick,
    onKeyPress: handleKeyAction,
    "data-locator": "accordion-heading-container"
  }, _react.default.createElement(_Heading.default, {
    className: "accordion-heading",
    HeadingType: "h5"
  }, heading), _react.default.createElement(_reactSvg.ReactSVG, {
    className: "accordionIcon",
    src: iconUrl,
    wrapper: "span",
    "data-locator": "accordion-icon-" + elementLocator
  })), isActive ? _react.default.createElement("div", {
    className: "body-container",
    "data-locator": "accordion-body"
  }, children) : null);
};
Accordion.defaultProps = {
  isLargeAccordion: false,
  collapseIcon: '',
  openIcon: '',
  elementLocator: '',
  isExpand: false
};
var _default = Accordion;
exports.default = _default;
module.exports = exports["default"];